




























import Vue from 'vue';

export default Vue.extend({
  name: 'FilterInput',
  props: {
    value: String,
    name: String,
    label: String,
    counter: Number,
    counterLabel: String,
    buttonMode: Boolean,
    iconCssVarName: String,
    iconActiveCssVarName: String,
    disabled: Boolean,
    locked: Boolean,
    noBorder: Boolean,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data(): {isFocused: boolean} {
    return {
      isFocused: false,
    };
  },
  computed: {
    inputId: function(): string {
      return this.name ? this.name : 'input-xxx';
    },
    inputListeners: function(): object {
      return {
        ...this.$listeners,
        change: (event: Event) => {
          //@ts-ignore
          this.$emit('change', (event.target as HTMLInputElement).value || '');
        },
        input: async (event: Event) => {
          const value = (event.target as HTMLInputElement).value;
          //@ts-ignore
          this.$emit('change', value || '');
          //@ts-ignore
          this.$emit('input', value || '');
        },
      };
    },
    cssClasses(): object {
      return {
        active: this.isFocused,
        disabled: this.disabled,
        locked: this.locked,
        'button-mode': this.buttonMode,
        'no-border': this.noBorder,
      };
    },
    cssStyles(): object {
      const varName = this.isFocused
        ? this.iconActiveCssVarName || `${this.iconCssVarName}-active`
        : this.iconCssVarName;

      return {
        'background-image': `var(${varName}`,
      };
    },
  },
  methods: {
    onFocus(): void {
      this.isFocused = true;
    },
    onBlur(): void {
      this.isFocused = false;
    },
  },
});
